import { css } from '@emotion/core';
import t from 'react-translate';

// Styles
import { gray4, gray6, success, getColorBetweenColorsByPercentage } from 'styles/global_defaults/colors';

type NvProgressBarProps = {
  currentValue: number
  maxValue: number
  courseClosed: boolean
  displayStatus?: boolean
  activeColor?: string,
};

const NvProgressBar = ({
  currentValue,
  maxValue,
  courseClosed,
  displayStatus,
  activeColor,
}: NvProgressBarProps) => {
  const barWidth = Math.round((Math.min(currentValue, maxValue) / maxValue) * 100);
  const barHeight = 6;
  const isCompleted = barWidth === 100;
  const inProgress = (!isCompleted && !courseClosed);

  let backgroundColor;
  let textColor;
  let progressLabel;

  if (isCompleted) {
    backgroundColor = success;
    textColor = 'success';
    progressLabel = t.INSTITUTIONS.LICENSES.COMPLETED();
  } else if (inProgress) {
    const startColor = getColorBetweenColorsByPercentage('#fff', activeColor, 0.4);
    backgroundColor = `linear-gradient(90deg, ${startColor} 0%, ${activeColor} 100%)`;
    textColor = 'primary';
    progressLabel = t.INSTITUTIONS.LICENSES.IN_PROGRESS();
  } else {
    backgroundColor = gray4;
    textColor = 'gray-3';
    progressLabel = t.INSTITUTIONS.LICENSES.INCOMPLETE();
  }

  const styles = () => css`
    width: 100%;

    .arrow {
      width: 0;
      height: 0;
      margin-bottom: 2px;
      margin-left: calc(${barWidth}% - ${barHeight}px);
      ${!inProgress ? 'visibility: hidden' : ''};
      border-left: ${barHeight}px solid transparent;
      border-right: ${barHeight}px solid transparent;
      border-top: ${barHeight}px solid ${activeColor};
    }

    .progress {
      height: ${barHeight}px;
      margin: 0;
      border-radius: 3px;
      background: ${gray6};

      .progress-bar {
        height: ${barHeight}px;
        width: ${barWidth}%;
        border-radius: 3px;
        background: ${backgroundColor};
      }
    }
`;

  return (
    <div css={styles()}>
      <div className='arrow' />
      <div className='progress'>
        <div className='progress-bar' />
      </div>
      {displayStatus && (
        <div className={`mt-1 label text-${textColor}`}>
          {progressLabel}
        </div>
      )}
    </div>
  );
};

export default NvProgressBar;
